import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { VIDEOS } from "@/data/content";
import HammersBackdrop from "@/components/site/HammersBackdrop";

export default function VideoShowcase() {
  return (
    <section
      id="videos"
      className="relative bg-paper py-24 md:py-32 overflow-hidden"
      data-testid="video-showcase-section"
    >
      <HammersBackdrop density="light" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#16a34a]">
              <Play className="w-3.5 h-3.5" fill="#16a34a" />
              In Motion
            </div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1c1917] mt-2 tracking-tight max-w-2xl">
              See the work in motion.{" "}
              <span className="text-[#57534e]">Real crews, real jobs.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {VIDEOS.map((v, i) => (
            <motion.figure
              key={v.src}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="relative aspect-[9/16] rounded-3xl overflow-hidden border border-[#e7e5df] bg-[#0f1d12] shadow-[0_20px_50px_-20px_rgba(0,0,0,0.4)]"
              data-testid={`video-item-${i}`}
            >
              <video
                src={v.src}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent pointer-events-none" />
              <figcaption className="absolute bottom-4 left-4 right-4 flex items-center gap-2 text-white text-sm font-bold drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)]">
                <span className="h-7 w-7 rounded-full bg-[#16a34a] inline-flex items-center justify-center">
                  <Play className="w-3.5 h-3.5" fill="#fff" stroke="#fff" />
                </span>
                {v.title}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
